import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/RequestCallback.css";

function RequestCallback() {
  const [fullName, setFullName] = useState("");
  const [mobile, setMobile] = useState("");
  const [studentClass, setStudentClass] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // ✅ VALIDATION
  const validate = () => {
    let newErrors = {};

    if (!fullName.trim()) {
      newErrors.fullName = "Full name is required";
    } else if (fullName.trim().length < 3) {
      newErrors.fullName = "Minimum 3 characters";
    }

    if (!mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(mobile)) {
      newErrors.mobile = "Enter valid 10-digit number";
    }

    if (!studentClass) {
      newErrors.studentClass = "Select a class";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ✅ SUBMIT
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    const newCallback = {
      id: Date.now(),
      fullName,
      mobile,
      studentClass,
      createdAt: new Date().toISOString(),
    };

    const existing =
      JSON.parse(localStorage.getItem("callbackRequests")) || [];

    localStorage.setItem(
      "callbackRequests",
      JSON.stringify([...existing, newCallback])
    );

    setLoading(false);
    alert("✅ Callback request submitted");

    // 🔗 WHATSAPP CONNECTION
    const phoneNumber = "919964585585"; // replace with your WhatsApp number
    const message = `Hello, I would like a callback.

    Name: ${fullName}
    Mobile: ${mobile}
    Class: ${studentClass}`;
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappURL, "_blank");

    setFullName("");
    setMobile("");
    setStudentClass("");

    navigate("/");
  };

  return (
    <div className="callback-wrapper">
      <div className="callback-card">
        {/* LEFT */}
        <div className="callback-left">
          <div className="icon">🚀</div>
          <h2>Request a Callback</h2>
          <p>Our advisor will contact you soon</p>
        </div>

        {/* RIGHT */}
        <form className="callback-right" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Full Name</label>
            <input
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
            {errors.fullName && (
              <span className="error-text">{errors.fullName}</span>
            )}
          </div>

          <div className="form-group">
            <label>Mobile Number</label>
            <input
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
            />
            {errors.mobile && (
              <span className="error-text">{errors.mobile}</span>
            )}
          </div>

          {/* 🔽 CLASS DROPDOWN */}
          <div className="form-group">
            <label htmlFor="classSelect">Select Class</label>
            <select
              id="classSelect"
              className="form-control"
              value={studentClass}
              onChange={(e) => setStudentClass(e.target.value)}
            >
              <option value="">-- Select Class --</option>
              {[
                "Class 5",
                "Class 6",
                "Class 7",
                "Class 8",
                "Class 9",
                "Class 10",
              ].map((cls) => (
                <option key={cls} value={cls}>
                  {cls}
                </option>
              ))}
            </select>
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default RequestCallback;
